
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
    selectedDropdown:{
        year:{},
        class_name:{}
    },
    List:[]
}
export const AssosiationList = createAsyncThunk('branch-list', async (searchParams,state) => {
    let res = await dataService.GetAPI(searchParams.endpoint);
    return res
})
const AssociationSlice = createSlice({

    name: 'association',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        },
        handleDropdownSelect: (state, action) => {
            state.selectedDropdown[action.payload.id] = action.payload.val
        },
        removeAssociationSelection:(state,action)=>{
            state.selectedDropdown={
                year:{},
                class_name:{}
            }
            state.List=[]
        }

    },
    extraReducers: {
        [AssosiationList.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [AssosiationList.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [AssosiationList.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading ,handleDropdownSelect,removeAssociationSelection} = AssociationSlice.actions;
export default AssociationSlice.reducer